import { useState, useEffect, useContext  } from 'react';

import {TransformDataForGrid}  from "../components/helpers";

import {CircularProgress,} from  '@mui/material';

import axios from 'axios';
import { Icon as Iconify } from '@iconify/react';

import { CcTitle, CcSubSectionTitle } from '../commonComponents/styledTexts';

import { object as yupObject, string, } from 'yup';
import { getErrorListFromYupError, getErrorMessage } from '../components/helperErrors';

import GaugeComponent from 'react-gauge-component';
import { ccColorSecondaryGreen, ccColorSecondaryAzure } from '../components/helpersStyles';

const CcAccountStatsGaugeTile = (props) => {
    const deltaPercentage = 0.1; //the plus/minus percentage band for the "OK on track" values
    const [showProgress, setShowProgress] = useState(true);
    const [expectedUsage, setExpectedUsage] = useState(0);
    const [actualUsage, setActualUsage] = useState(0);

    useEffect(() => {
        if (props.stats) {
            
          if (props.stats === 0) {
              setExpectedUsage(0)
              setActualUsage(0)
              setShowProgress(false)
              return
          }
          const start = new Date(props.stats.periodInfo.periodStart)
          const end = new Date(props.stats.periodInfo.periodEnd)
          const periodImpressions = props.stats.periodInfo.impressions
          const periodDays = Math.floor((end - start) / (1000 * 60 * 60 * 24));
          const daysPassed = Math.floor((new Date() - start) / (1000 * 60 * 60 * 24));
          const expectedDailyImpressions = Math.floor(periodImpressions / periodDays)
          const actualDailyImpressions = Math.floor(props.stats.totalImpressions / daysPassed)
          //const actualDailyImpressions = 100
          
          setActualUsage(actualDailyImpressions);
          setExpectedUsage(expectedDailyImpressions)
          setShowProgress(false)
            

        }
    }, [props.stats])

    const prettyLabel = (val) => {
      
      return Math.floor(val) + ' imp/day'
    }

    return <div className='h-[400px] px-6 py-5 w-full font-poppins bg-slate-800'>
        {showProgress && <div className='flex flex-row justify-center mt-4 text-white'> <CircularProgress size={32} color='inherit'  /></div>}


        {!showProgress && <>
            {expectedUsage === 0 ?
                <div className=' text-white font-bold text-3xl'>0</div>
            :
            <div className=''>
                <GaugeComponent
                    style={{height: '100px'}}
                    type="radial"
                    marginInPercent={{ top: 0.08, bottom: 0.1, left: 0.0, right: 0.0 }}
                    arc={{
                        //colorArray: ['#00FF15', '#FF2121',],
                        padding: 0.02,
                        subArcs:
                        [
                            { limit: expectedUsage - deltaPercentage*expectedUsage, color: '#F5CD19',  },
                            { limit: expectedUsage + deltaPercentage*expectedUsage, color: '#5BE12C',  },
                            { limit: 2*expectedUsage, color: '#EA4228',  },
                            {}
                        ]
                    }}
                    pointer={{type: "blob", animationDelay: 0, color: '#ccc' }}
                    value={actualUsage}
                    minValue={0}
                    maxValue={2*expectedUsage}
                    labels={{valueLabel: {hide: false, style: {textShadow: ''}}, tickLabels: {ticks: [{value: expectedUsage - deltaPercentage*expectedUsage}, {value: expectedUsage + deltaPercentage*expectedUsage}], type: 'outer', defaultTickLineConfig: {hide: false, color: '#fff'}, defaultTickValueConfig: {hide: false, formatTextValue: prettyLabel, style: {fill: '#fff'}}}}}
                />
            </div>
        }
            

        </>
        }
    </div>
}
const AccountPacingSummary = (props) => {
    const deltaPercentage = 0.1; //the plus/minus percentage band for the "OK on track" values
    const [showProgress, setShowProgress] = useState(true);
    const [expectedUsage, setExpectedUsage] = useState(0);
    const [actualUsage, setActualUsage] = useState(0);
    const [remainingImpressions, setRemainingImpressions] = useState(0);

    useEffect(() => {
        if (props.stats) {
          //console.log(props.stats)
            
          if (props.stats === 0) {
              setExpectedUsage(0)
              setActualUsage(0)
              setShowProgress(false)
              return
          }
          const start = new Date(props.stats.periodInfo.periodStart)
          const end = new Date(props.stats.periodInfo.periodEnd)
          const periodImpressions = props.stats.periodInfo.impressions
          const periodDays = Math.floor((end - start) / (1000 * 60 * 60 * 24));
          const daysPassed = Math.floor((new Date() - start) / (1000 * 60 * 60 * 24));
          const expectedDailyImpressions = Math.floor(periodImpressions / periodDays)
          const actualDailyImpressions = Math.floor(props.stats.totalImpressions / daysPassed)
          //const actualDailyImpressions = 100
          
          setActualUsage(actualDailyImpressions);
          setExpectedUsage(expectedDailyImpressions)
          setRemainingImpressions(periodImpressions - props.stats.totalImpressions)
          setShowProgress(false)
            

        }
    }, [props.stats])

    const classifyUsage = () => {
        if (expectedUsage > 0 && actualUsage >= expectedUsage - deltaPercentage*expectedUsage
            && actualUsage <= expectedUsage + deltaPercentage*expectedUsage)
            return "ok"
        else if (expectedUsage > 0 && actualUsage < expectedUsage - deltaPercentage*expectedUsage)
            return "low"
        else
            return "high"
    }
    const getUsageMessage = () => {
        switch (classifyUsage()) {
            case "ok":
                return "Your impression usage is pacing as expected and right on track."
            case "low":
                return "You’re consuming fewer impressions than available, leaving unused images this period."
            case "high":
                return "You’re consuming impressions faster than planned and may reach your limit early."
            default:
                return ""
        }
    }
    const OneWordLabel = () => {
        if (classifyUsage() === 'ok')
        return <div className='bg-slate-200 px-2 py-1 w-fit rounded text-green-600 font-semibold flex flex-row items-center gap-x-1'>Pacing is OK</div>
        if (classifyUsage() === 'low')
        return <div className='bg-slate-200 px-2 py-1 w-fit rounded text-yellow-600 font-semibold flex flex-row items-center gap-x-1'>Pacing is LOW</div>
        if (classifyUsage() === 'high')
        return <div className='bg-slate-200 px-2 py-1 w-fit rounded text-red-600 font-semibold flex flex-row items-center gap-x-1'>Pacing is HIGH</div>
    }

    const prettyLabel = (val) => {
      
      return Math.floor(val) + ' imp/day'
    }

    return <div className='h-[400px] px-6   font-poppins '>
        {showProgress && <div className='flex flex-row justify-center mt-4 text-white'> <CircularProgress size={32} color='inherit'  /></div>}


        {!showProgress && <>
            {expectedUsage === 0 ?
                <div className=' text-white font-bold text-3xl'></div>
            :
            <div>
              <div className='border rounded p-2'>
                <OneWordLabel />
                <div className='flex flex-col gap-y-2 mt-2 text-sm'>
                  <div><span className='font-semibold'>Actual usage:</span> {actualUsage} avg impressions/day</div>
                  <div><span className='font-semibold'>Expected usage:</span> {expectedUsage} avg impressions/day</div>
                  <div className='mt-1'>{getUsageMessage()}</div>
                  </div>
              </div>
              <div className='border rounded p-2 mt-2'>
                <div className='font-semibold text-ccColorDarkTeal'>Purchased impressions: <span className='text-2xl'>{new Intl.NumberFormat().format(props.stats.periodInfo.impressions)}</span></div>
                <div className='flex flex-row gap-x-4 text-sm text-slate-500'><div>From: {props.stats.periodInfo.periodStart}</div><div>To: {props.stats.periodInfo.periodEnd}</div></div>
                <div className='font-semibold text-ccColorDarkTeal mt-2'>Used impressions: <span className='text-2xl'>{new Intl.NumberFormat().format(props.stats.totalImpressions)}</span></div>
                <div className='font-semibold text-ccColorDarkTeal mt-2'>Remaining impressions: <span className='text-2xl'>{new Intl.NumberFormat().format(remainingImpressions)}</span></div>
                <div className='text-sm text-slate-500'>Consume by: {props.stats.periodInfo.periodEnd}</div>
              </div>

            </div>
        }
            

        </>
        }
    </div>
}

export default function PageAdminPacing() {
    /*
    props:

    NO props 
    */
    const [pacingStats, setPacingStats] = useState(undefined);
    const [pacingDailyBreakdown, setPacingDailyBreakdown] = useState([]);

    const [showLoader, setShowLoader] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [showErrorMsg, setShowErrorMsg] = useState('');
    const [showAlreadyExistsMsg, setShowAlreadyExistsMsg] = useState(false);


    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogData, setDialogData] = useState({action: '', id:'', title:'', desc:''});
  
  
    useEffect(() => {
        getPacingStats()
        getPacingDailyBreakdown();
    }, [])

    const getPacingStats = async () => {
        try {
            // const url = `api/Stats/${endpoint}`;
            const url = `${process.env.REACT_APP_LION_API_URL}/Stats/opens/pacing`

            const response = await axios.get(url);
            const data = response.data;
            setPacingStats(data)
            
                    
        } catch (error) {
          setPacingStats(undefined)
            console.log(error);
        }  

        }
    const getPacingDailyBreakdown = async () => {
        try {
            // const url = `api/Stats/${endpoint}`;
            const url = `${process.env.REACT_APP_LION_API_URL}/Stats/opensByDay/currentPeriod`

            const response = await axios.get(url);
            const data = response.data;
            setPacingDailyBreakdown(data)
            
                    
        } catch (error) {
          setPacingDailyBreakdown([])
            console.log(error);
        }  

        }

    return <div>
      <CcTitle>Pacing</CcTitle>
      <div className='mt-2 text-ccColorDarkTeal'>Review and track your image impression usage to see whether you’re pacing high, on target, or below expected, with daily trends, averages, and overall usage status.</div>
      <div className='flex flex-row items-center mt-2'>
        <div className='w-[580px]'>
         <CcAccountStatsGaugeTile  title='Pacing'
                                        stats={pacingStats}
                                        />
         
        </div>
        <AccountPacingSummary stats={pacingStats} />

      </div>
      <CcSubSectionTitle className="mt-4">Usage daily breakdown</CcSubSectionTitle>
      {pacingStats && <div className='flex flex-row gap-x-4 text-sm text-slate-500'><div>From: {pacingStats.periodInfo.periodStart}</div><div>To: {pacingStats.periodInfo.periodEnd}</div></div>}
      <div className='border rounded max-w-xl px-2 max-h-96 overflow-auto'>
        <div className='flex flex-row py-0.5 text-ccColorDarkTeal font-poppins font-semibold'><div className='w-28'>Day</div><div>Impressions</div></div>
        {pacingDailyBreakdown.map((day, index) => <div className={`flex flex-row py-0.5 ${index % 2 === 0 ? 'bg-slate-200': ''}`}>
            <div className='w-28'>{day.date}</div>
            <div>{day.impressions}</div>
        </div>)}
      </div>

</div>
}